// extracted by mini-css-extract-plugin
export default {"fr-view":"Multi_fr-view__RvAPy","container":"Multi_container__Y8ziz"};